import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "12",
  viewBox: "0 0 20 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M4 4.1875L10 7.81201L16 4.1875",
      stroke: "#CCCCCC",
      "stroke-width": "2.25",
      "stroke-miterlimit": "10"
    }, null, -1)
  ]))]))
}
export default { render: render }